import { Option } from 'react-select';

export const bannerBackgroundColorOptions: Array<Option<string>> = [
  {
    label: 'danger',
    value: 'var(--color-danger)',
  },
  {
    label: 'danger-light',
    value: 'var(--color-danger-light)',
  },
  {
    label: 'alert',
    value: 'var(--color-alert)',
  },
  {
    label: 'alert-light',
    value: 'var(--color-alert-light)',
  },
  {
    label: 'warning',
    value: 'var(--color-warning)',
  },
  {
    label: 'warning-light',
    value: 'var(--color-warning-light)',
  },
  {
    label: 'success',
    value: 'var(--color-success)',
  },
  {
    label: 'success-light',
    value: 'var(--color-success-light)',
  },
  {
    label: 'accessory',
    value: 'var(--color-accessory)',
  },
  {
    label: 'accessory-light',
    value: 'var(--color-accessory-light)',
  },
];

export const bannerTextColorOptions: Array<Option<string>> = [
  {
    label: 'text-primary',
    value: 'var(--color-text-primary)',
  },
  {
    label: 'text-secondary',
    value: 'var(--color-text-secondary)',
  },
  {
    label: 'text-accent',
    value: 'var(--color-text-accent)',
  },
  {
    label: 'text-caption',
    value: 'var(--color-text-caption)',
  },
  {
    label: 'text-link',
    value: 'var(--color-text-link)',
  },
  {
    label: 'text-on-dark',
    value: 'var(--color-text-on-dark)',
  },
];
